export const privacyPolicyBodyFr = `Dernière mise à jour : 3 octobre 2026

La présente information décrit les modalités de traitement des données personnelles des utilisateurs qui utilisent le portail en ligne de pro20.net pour effectuer des réservations, des commandes, des demandes d'information et les autres services mis à disposition.

## 1. Responsable du traitement

Le responsable du traitement des données personnelles est :

Mada Srl

Nom commercial : Mada Srl

Siège : Via 4 novembre 12 - Cisternino (BR) 72014

N° de TVA / code fiscal : 02750160745

E-mail : {{email}}

PEC : -

Pour toute demande relative à la protection des données personnelles, vous pouvez contacter le responsable aux coordonnées indiquées ci-dessus.

Si un délégué à la protection des données (DPO) a été désigné, vous pouvez le contacter à l'adresse :

{{email}}

## 2. Types de données traitées

Dans le cadre de l'utilisation du portail, peuvent être collectées et traitées, selon les services utilisés :

- nom et prénom ;
- adresse e-mail ;
- numéro de téléphone et indicatif ;
- informations relatives aux réservations ;
- nombre de personnes associées à la réservation ;
- date et heure de la réservation ;
- informations et demandes saisies volontairement par l'utilisateur ;
- historique des réservations et des présences ;
- informations relatives aux commandes effectuées ;
- produits et services achetés ;
- informations relatives à la livraison ou au retrait des commandes ;
- informations relatives aux transactions et à l'état des paiements ;
- éventuels codes promotionnels, coupons, points ou programmes de fidélité ;
- préférences et consentements exprimés par l'utilisateur ;
- données techniques nécessaires au fonctionnement et à la sécurité du portail.

L'utilisateur est invité à ne pas saisir, dans les notes ou les demandes libres, d'informations non nécessaires, en particulier des données personnelles appartenant à des catégories particulières au sens de l'article 9 du RGPD, sauf lorsque cela est strictement nécessaire à la gestion de la demande.

## 3. Finalités et bases juridiques du traitement

### 3.1 Réservations

Les données personnelles sont traitées pour :

- recevoir et gérer une demande de réservation ;
- confirmer, modifier ou annuler une réservation ;
- contacter le client au sujet de la réservation ;
- gérer l'arrivée et la présence au restaurant ;
- gérer d'éventuelles demandes liées à la réservation.

La base juridique est l'exécution d'un contrat ou de mesures précontractuelles demandées par la personne concernée conformément à l'article 6, paragraphe 1, point b), du RGPD.

## 4. Commandes, à emporter et livraison

Lorsque le portail permet de passer des commandes, les données personnelles peuvent être utilisées pour :

- recevoir et gérer la commande ;
- préparer les produits commandés ;
- gérer le retrait sur place ;
- organiser la livraison éventuelle ;
- communiquer des mises à jour sur l'état de la commande ;
- gérer les modifications, annulations ou remboursements ;
- fournir une assistance au client.

La base juridique est l'exécution du contrat ou de mesures précontractuelles demandées par la personne concernée.

## 5. Paiements

Lorsqu'il est prévu, le portail peut permettre le paiement de commandes, d'acomptes, d'arrhes, de services ou d'autres sommes par l'intermédiaire de prestataires spécialisés de services de paiement.

Les données nécessaires à la transaction peuvent être communiquées directement au prestataire de services de paiement.

Le restaurant et le portail peuvent recevoir des informations sur l'issue de la transaction, par exemple :

- paiement effectué ;
- paiement refusé ;
- autorisation de la carte ;
- acompte effectué ;
- remboursement ;
- identifiant de la transaction.

Les données complètes de la carte de paiement ne sont pas conservées par le restaurant lorsque le paiement est géré directement par le prestataire de paiement.

La base juridique est l'exécution du contrat et, le cas échéant, le respect d'une obligation légale.

## 6. Communications relatives au service

Les coordonnées fournies par l'utilisateur peuvent être utilisées pour envoyer des communications strictement liées au service demandé, par exemple :

- confirmation de la réservation ;
- demande de confirmation ;
- modification ou annulation de la réservation ;
- rappel de la réservation ;
- confirmation de la commande ;
- mise à jour de l'état de la commande ;
- communications relatives au paiement ;
- informations nécessaires à la bonne exécution du service.

Ces communications pourront être effectuées, selon les coordonnées fournies et les services activés par le restaurant, par e-mail, SMS, WhatsApp ou d'autres systèmes de messagerie.

Lorsqu'elles sont strictement nécessaires à la gestion du service demandé, ces communications ne constituent pas des communications promotionnelles.

## 7. Marketing et communications promotionnelles

Uniquement avec le consentement de l'utilisateur, les données de contact pourront être utilisées pour l'envoi de communications commerciales et promotionnelles relatives à :

- offres et promotions ;
- événements ;
- nouveaux menus ou produits ;
- initiatives du restaurant ;
- coupons et codes de réduction ;
- programmes de fidélité ;
- communications commerciales personnalisées.

Les communications pourront être envoyées par les canaux pour lesquels l'utilisateur a donné son consentement, tels que l'e-mail, le SMS, WhatsApp ou d'autres moyens autorisés par la réglementation applicable.

Le consentement à des fins de marketing est facultatif.

L'absence de consentement n'empêche pas d'effectuer des réservations, des commandes ou d'utiliser les autres services principaux du portail.

Le consentement peut être retiré à tout moment, sans porter atteinte à la licéité des traitements effectués avant le retrait.

## 8. Profilage et personnalisation

Uniquement lorsqu'il est prévu et avec le consentement lorsque la réglementation l'exige, le responsable pourra utiliser des informations relatives aux interactions de l'utilisateur avec le restaurant pour analyser des intérêts, des habitudes et des préférences.

À titre d'exemple, peuvent être prises en compte des informations telles que :

- fréquence des réservations ;
- historique des commandes ;
- produits achetés ;
- utilisation de promotions et de coupons ;
- participation à des programmes de fidélité ;
- préférences exprimées par l'utilisateur ;
- interactions avec des communications promotionnelles.

Ces informations peuvent être utilisées pour créer des segments de clientèle et rendre les offres, promotions et communications plus pertinentes.

Le consentement au profilage, lorsqu'il est requis, est facultatif et peut être retiré à tout moment.

L'absence de consentement n'empêche pas l'utilisation des services habituels de réservation et de commande.

## 9. Programmes de fidélité, promotions et coupons

Lorsque le restaurant propose des programmes de fidélité, des promotions, des collectes de points ou des coupons, les données de l'utilisateur peuvent être traitées pour :

- attribuer des points ou des avantages ;
- vérifier les conditions d'obtention d'une promotion ;
- générer des coupons ;
- vérifier l'utilisation des coupons ;
- gérer des récompenses et des avantages ;
- prévenir les utilisations frauduleuses des promotions.

Les conditions spécifiques du programme ou de la promotion peuvent être régies par un règlement dédié.

## 10. Automatisations

Le restaurant peut utiliser des systèmes automatiques pour gérer certaines activités liées à la relation avec le client.

Par exemple, le système peut automatiquement :

- envoyer un rappel avant une réservation ;
- envoyer une communication après une visite ;
- mettre à jour l'état d'une réservation ou d'une commande ;
- attribuer des points ou des coupons ;
- envoyer des communications lorsque certaines conditions se réalisent.

Lorsque ces automatisations ont une finalité promotionnelle ou comportent un profilage, les bases juridiques correspondantes s'appliquent et, lorsque cela est nécessaire, le consentement de l'utilisateur est demandé au préalable.

## 11. Communication des données

La communication des données indiquées comme obligatoires est nécessaire pour fournir le service demandé.

Par exemple, l'absence des données nécessaires à la réservation peut rendre impossible de finaliser la réservation.

La communication des données et du consentement à des fins de marketing et de profilage est en revanche facultative et ne conditionne pas l'accès aux services principaux.

## 12. Destinataires des données

Les données personnelles peuvent être traitées par du personnel autorisé par le responsable et par des fournisseurs qui fournissent des services nécessaires au fonctionnement de l'activité et de la plateforme.

À titre d'exemple, peuvent notamment être concernés :

- les fournisseurs de la plateforme informatique ;
- les hébergeurs et fournisseurs de services cloud ;
- les fournisseurs de services d'e-mail ;
- les fournisseurs de services SMS ;
- les fournisseurs de services de messagerie ;
- les fournisseurs de services de paiement ;
- les fournisseurs de services de livraison ;
- les conseils techniques, administratifs ou fiscaux ;
- d'autres personnes qui traitent des données pour le compte du responsable.

Lorsque la réglementation le prévoit, ces personnes agissent en qualité de sous-traitants au sens de l'article 28 du RGPD.

Les données pourront également être communiquées aux autorités compétentes lorsqu'une obligation légale l'exige.

## 13. Transfert des données en dehors de l'Espace économique européen

Certains fournisseurs technologiques utilisés par le responsable pourraient traiter des données personnelles en dehors de l'Espace économique européen.

Dans ces cas, le traitement et le transfert des données seront effectués dans le respect du RGPD, au moyen des instruments et garanties applicables, tels que des décisions d'adéquation ou des clauses contractuelles types approuvées par la Commission européenne, lorsque cela est nécessaire.

## 14. Durée de conservation

Les données personnelles sont conservées pendant le temps nécessaire à la poursuite des finalités pour lesquelles elles ont été collectées, puis pendant les éventuelles durées exigées par la réglementation applicable.

En particulier :

- les données relatives aux réservations et aux commandes seront conservées pendant la période nécessaire à la gestion de la relation avec le client et aux éventuelles obligations administratives, comptables ou légales ;
- les données relatives aux transactions seront conservées conformément aux obligations fiscales et comptables applicables ;
- les données utilisées à des fins de marketing seront conservées jusqu'au retrait du consentement ou pendant une autre période fixée par le responsable selon les principes de nécessité et de proportionnalité ;
- les données utilisées pour le profilage seront conservées pendant la période définie par le responsable au regard des finalités poursuivies, puis supprimées ou anonymisées.

Les durées précises de conservation adoptées par le responsable peuvent être demandées aux coordonnées indiquées dans la présente information.

## 15. Sécurité des données

Le responsable et les fournisseurs concernés adoptent des mesures techniques et organisationnelles adaptées au risque afin de protéger les données personnelles contre la perte, la destruction, l'accès non autorisé, la divulgation, la modification ou le traitement illicite.

## 16. Droits de la personne concernée

Dans les cas prévus par le RGPD, la personne concernée peut exercer ses droits et notamment demander :

- l'accès à ses données personnelles ;
- la rectification des données inexactes ;
- l'effacement des données ;
- la limitation du traitement ;
- la portabilité des données ;
- l'opposition au traitement ;
- le retrait du consentement précédemment donné.

Le retrait du consentement ne porte pas atteinte à la licéité du traitement effectué avant le retrait.

Les demandes peuvent être envoyées à :

{{email}}

La personne concernée a également le droit d'introduire une réclamation auprès de l'autorité italienne de protection des données (Garante per la protezione dei dati personali) selon les modalités prévues par la réglementation en vigueur.

## 17. Cookies et technologies analogues

Le portail peut utiliser des cookies et d'autres technologies nécessaires à son fonctionnement.

L'éventuelle utilisation de cookies analytiques, de profilage ou de tiers est régie par la politique cookies spécifique disponible sur le portail et, lorsque cela est nécessaire, par le système de gestion du consentement.

## 18. Modifications de la présente information

Le responsable peut mettre à jour périodiquement la présente information afin de l'adapter à des modifications réglementaires, techniques ou des services offerts.

La version mise à jour sera mise à disposition par l'intermédiaire du portail.

Dernière mise à jour : 03 octobre 2026`;
